var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleBrokenUpLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5895 21.6606C11.2533 22.5515 7.54616 21.6884 4.92887 19.0711C1.02363 15.1658 1.02363 8.83418 4.92887 4.92893C8.83411 1.02369 15.1658 1.02369 19.071 4.92893C21.6883 7.54623 22.5515 11.2534 21.6606 14.5896M9.00017 15.0001V9.0001M9.00017 9.0001H15.0002M9.00017 9.0001L19 19",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleBrokenUpLeft);
export default __webpack_public_path__ + "static/media/arrow-circle-broken-up-left.86fc94bae33b0f7884d498ae6573dc14.svg";
export { ForwardRef as ReactComponent };